import React from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
}));

const useSteperStyleStyles = makeStyles({
  root: {
    backgroundColor: '#fff',
    zIndex: 1,
    color: '#676a6c',
    width: 30,
    height: 30,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #000 ',
    fontWeight: '600',
  },
  active: {
    backgroundColor: '#000',
    color: '#fff',
  },
});

function SteperStyle(props) {
  const classes = useSteperStyleStyles();
  const { active, completed } = props;

  const icons = {
    1: '1',
    2: '2',
    3: '3',
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}>
      {icons[String(props.icon)]}
    </div>
  );
}

const steps = ['Choose Order Type', 'Add Shipping Information', 'Add Products'];

const CreateOrderStepper = ({ activeStep }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step className={classes.test} key={label}>
            <StepLabel StepIconComponent={SteperStyle}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

export default CreateOrderStepper;

SteperStyle.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,

  icon: PropTypes.node,
};
